import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#3A3247",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.998 6.002c1.208 0 2.19.982 2.19 2.19s-.982 2.191-2.19 2.191a2.194 2.194 0 0 1-2.191-2.19c0-1.209.982-2.191 2.19-2.191ZM12 12.386A4.193 4.193 0 1 0 12 4a4.193 4.193 0 0 0 0 8.387Zm6.541 2.707a9.5 9.5 0 0 1-1.275 1.131c-.966-1.917-3.004-3.193-5.252-3.193-2.252 0-4.3 1.28-5.263 3.207a9.6 9.6 0 0 1-1.292-1.145L4 16.46C6.135 18.743 8.976 20 12.001 20s5.865-1.257 7.999-3.538zm-10.05 2.166a8.7 8.7 0 0 0 7.044-.01c-.604-1.322-1.983-2.214-3.52-2.214-1.54 0-2.923.897-3.524 2.224",
  clipRule: "evenodd"
})));

export { SvgUser as ReactComponent };
//# sourceMappingURL=User.svg.js.map
